// assets/auto-packaging.js
class AutoPackaging {
    constructor(config) {
        // 绑定方法保持上下文
        this.syncPackaging = this.syncPackaging.bind(this);
        this.fetchCart = this.fetchCart.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.removeFromCart = this.removeFromCart.bind(this);

        // 配置
        this.PACKAGING_VARIANT_ID = Number(config.variantId);
        this.DEBUG_MODE = config.debug || false;

        // 状态控制
        this.isHandlingCart = false;

        // 初始化（延迟执行避免冲突）
        this.initEvents();
        this.syncPackaging();
    }

    // 使用箭头函数自动绑定this（替代手动bind）
    fetchCart = async () => {
        const response = await fetch('/cart.js');
        return response.json();
    }

    // 增强版同步逻辑
    async syncPackaging() {
        //return;
        if (this.isHandlingCart) {
            this.log('操作已在进行中，跳过本次执行');
            return;
        }

        this.isHandlingCart = true;
        this.log('开始检查包装产品...');


        try {

            let cart = await this.fetchCart();
            if (!cart) {
                this.log("购物车状态不稳定，放弃本次操作");
                return;
            }

            const hasMainItems = cart.items.some(item => item.variant_id !== this.PACKAGING_VARIANT_ID);
            const packagingItem = cart.items.find(item => item.variant_id === this.PACKAGING_VARIANT_ID);

            this.log("cart.items", cart.items);
            this.log(this.PACKAGING_VARIANT_ID)
            this.log("hasMainItems", hasMainItems)
            this.log("packagingItem", packagingItem)

            if (hasMainItems && !packagingItem) {
                this.log('检测到主商品，正在添加包装...');
                await this.addToCart(this.PACKAGING_VARIANT_ID);
            } else if (!hasMainItems && packagingItem) {
                this.log('无主商品，正在移除包装...');
                await this.removeFromCart(packagingItem.key);
            }
        } catch (error) {
            console.error('AutoPackaging 错误:', error);
        } finally {
            this.isHandlingCart = false;
        }
    }


    // 增强版添加方法
    async addToCart(variantId) {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: 1,
                    properties: {
                        _auto_gift: 'true' // 标记为自动添加的赠品
                    }
                }]
            })
        });

        const result = await response.json();
        this.log('添加结果:', result);
        this.refreshCartUI();
        return result;
    }

    // 增强版移除方法
    async removeFromCart(lineItemKey) {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                id: lineItemKey,
                quantity: 0,
                properties: null // 清除可能存在的属性
            })
        });
        const result = await response.json();
        this.log('移除结果:', result);
        const cartItemsWrapper = document.querySelector('.drawer__cart-items-wrapper');
        if (cartItemsWrapper) {
            cartItemsWrapper.remove();
        }
        const cartFooterWrapper = document.querySelector('.drawer__footer');
        if (cartFooterWrapper) {
            cartFooterWrapper.remove();
        }
        const cartFetherWrapper = document.querySelector('.fether-widget');
        if (cartFetherWrapper) {
            cartFetherWrapper.remove();
        }
        const cartCountBubbleWrapper = document.querySelector('.cart-count-bubble');
        if (cartCountBubbleWrapper) {
            cartCountBubbleWrapper.remove();
        }
        const progressWrapper = document.querySelector('.cart-progress-bar-container');
        if (progressWrapper) {
            progressWrapper.remove();
        }
    
        if (window.location.pathname === '/cart') {
            window.location.reload();
        }
        return result;
    }

    // 更可靠的事件监听
    initEvents() {

        // 标准化事件监听
        const safeHandler = debounce(() => this.syncPackaging(), 1000);


        // 兼容多种主题事件
        const events = [
            'ajaxCart:afterAdd',
            'ajaxCart:afterUpdate',
            'ajaxCart:afterRemove',
            'cart:updated',
            'cart:change',
            'cart:requestComplete'
        ];

        events.forEach(event => {
            document.addEventListener(event, safeHandler);
        });

        // 表单提交兜底
        document.addEventListener('submit', (e) => {
            if (e.target.action?.match(/\/cart\/(add|change|update)/)) {
                safeHandler();
            }
        });

        // 拦截fetch/XHR请求（兜底方案）
        this.interceptCartRequests();

    }

    // 新增：请求拦截器
    interceptCartRequests() {
        const originalFetch = window.fetch;
        window.fetch = async (input, init) => {
            const res = await originalFetch(input, init);
            if (typeof input === 'string' && input.includes('/cart/change')) {
                setTimeout(() => this.syncPackaging(), 1000);
            }
            return res;
        };
    }


    log(message, data) {
        if (this.DEBUG_MODE) {
            console.log(`[AutoPackaging] ${message}`, data || '');
        }
    }

    refreshCartUI() {
        document.querySelector('form.cart__contents input.quantity__input').dispatchEvent(new Event("change", {bubbles: true}));
    }
}

// 安全初始化
document.addEventListener('DOMContentLoaded', () => {
    if (window.PackagingConfig && window.PackagingConfig.variantId) {
        try {
            new AutoPackaging(window.PackagingConfig);
        } catch (e) {
            console.error('AutoPackaging 初始化失败:', e);
        }
    }
});